<template>
    <div style="display: flex; flex-direction: column; background-color: #fff;">
        <div v-if="isShowRecommendCodePopup" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 10;">
            <div style="width: calc(100% - 40px); background-color: #ececec; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); border-radius: 22px;">
                <div style="position: relative;">
                    <div @click="closeRecommendCodePopup" style="padding-left: 20px; padding-top: 18px; font-weight: 700; font-size: 15px; line-height: 22px;">닫기</div>
                    <div style="position: absolute; left: 50%; transform: translateX(-50%); top: 25px;">
                        <img style="width: 66px;" :src="require('@/assets/img/soccerhow_text_banner.png')" alt="">
                    </div>
                </div>
                <div style="margin-top: 21px; text-align: center;">
                    <div style="font-weight: 900; font-size: 24px; line-height: 32px; color: var(--color-main); margin-bottom: 6px;">친구 초대하고 포지션 찾기</div>
                    <div style="font-weight: 400; font-size: 15px; line-height: 18px;">친구가 내 추천인 코드로 가입하면<br>포지션 찾기 Pro를 무료로 이용할 수 있어요!</div>
                </div>
                <div style="padding: 0 20px; margin-top: 14px;">
                    <div style="background-color: #fff; border-radius: 18px; display: flex; justify-content: center; align-items: center;">
                        <div style="padding-top: 28px; padding-bottom: 24px; text-align: center;">
                            <div style="font-weight: 700; font-size: 24px; line-height: 32px;">내 추천인 코드</div>
                            <div style="font-weight: 700; font-size: 32px; line-height: 44px;">{{ myRecommendCode }}</div>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 12px; display: flex; justify-content: center; gap: 32px; padding-bottom: 15px;">
                    <!--<div style="border-radius: 50%; border: 1px solid #c3c3c3; overflow: hidden; width: 56px; height: 56px; display: flex; justify-content: center; align-items: center;">-->
                        <!--<img style="width: 38px;" :src="require('@/assets/img/kakao_link.png')" alt="">-->
                    <!--</div>-->
                    <!--<div @click="copyMyRecommendCode" style="border-radius: 50%; border: 1px solid #c3c3c3; overflow: hidden; width: 56px; height: 56px; display: flex; justify-content: center; align-items: center;">-->
                        <!--<img style="width: 52px;" :src="require('@/assets/img/copy_link.png')" alt="">-->
                    <!--</div>-->

                    <div @click="copyMyRecommendCode" style="background: #FFFFFF;border: 1px solid #E0E0E0;border-radius: 20px;letter-spacing: -0.05em;color: #000000;font-weight: 500; font-size:15px; padding:14px 20px; margin:7px 0px;">코드 복사하기</div>
                </div>
            </div>
        </div>
        <div style="display: flex; justify-content: space-between; padding: 14px 12px; background-color: #ffffffE5; position: relative;">
            <div style="display:flex; align-items: center; " @click="() => { $GlobalStore.closeLastModal() }">
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width: 10px; transform: rotate(180deg);">
                <span style="font-size:14px; font-weight:500; margin-left:5px;">뒤로가기</span>
            </div>
            <div style="position: absolute; left: 50%; transform: translateX(-50%);">
                <img style="width: 70px;" :src="require('@/assets/img/soccerhow_black.png')" alt="">
            </div>
            <div @click="shareUrl">
                <img style="width: 18px;" :src="require('@/assets/img/share_white.png')" alt="">
            </div>
        </div>
        <div style="overflow-y: scroll; flex: 1; overflow-x: hidden;">
            <div :style="{ background: type === POSITION_TYPE.LITE ? '#341A00' : 'linear-gradient(180deg, #003255 0%, #210F03 41.59%)' }" style="padding: 32px 20px;">
                <!-- <div style="display: flex; gap: 12px; color: #fff; justify-content: flex-end;">
                    <div @click="setType(POSITION_TYPE.LITE)" style="cursor: pointer;" :style="{ fontWeight: type === POSITION_TYPE.LITE ? '700' : '400' }">{{ headerText.position_lite_btn }}</div>
                    <div @click="setType(POSITION_TYPE.PRO)" style="cursor: pointer;" :style="{ fontWeight: type === POSITION_TYPE.PRO ? '700' : '400' }">{{ headerText.position_pro_btn }}</div>
                </div> -->
                <div style="text-align: center;">
                    <img style="width: 136px;" :src="require(`@/assets/img/${type}_ground.png`)" alt="">
                    <div style="margin-top: 40px; color: #fff;">
                        <div style="font-weight: 700; font-size: 24px; line-height: 28px;">{{ type === POSITION_TYPE.LITE ? headerText.title.lite : headerText.title.pro }}</div>
                        <div v-html="subTitle" style="font-weight: 500; line-height: 24px; margin-top: 20px;"></div>
                    </div>
                </div>
                <div style="text-align: center; margin-top: 40px;">
                    <div v-if="type === POSITION_TYPE.LITE" style="display: inline-block; cursor: pointer; border-radius: 100px;">
                        <div @click="checkIsWrite" style="-webkit-appearance:none; outline: none;border:0px;display: flex; align-items: center; gap: 10px;padding: 12px 20px; cursor: pointer; border-radius: 100px; background-color: var(--color-main);">
                            <span style="font-weight: 700; font-size: 14px; line-height: 24px; cursor: pointer;">포지션 찾기 시작하기</span>
                            <img style="width: 16px;" :src="require(`@/assets/img/do_${type}.png`)" alt="">
                        </div>
                    </div>
                    <div v-else style="display: flex; justify-content: center; gap: 20px;">
                        <div v-if="isAvailableFindProFree || available_cnt > 0" style="width: 115px; height: 48px; line-height: 48px; text-align: center; border-radius: 100px; background-color: #315997; color: #fff; font-size: 14px; font-weight: 900;" @click="showMyPositionProMain">시작하기</div>
                        <div v-else style="width: 115px; height: 48px; line-height: 48px; text-align: center; border-radius: 100px; background-color: #315997; color: #fff; font-size: 14px; font-weight: 900;" @click="paymentPositionPro">₩ {{price | comma}}</div>
                        <div @click="showPopupOrFreePro" style="width: 115px; position: relative; height: 48px; text-align: center; border-radius: 100px; background-color: #315997; color: #fff; font-size: 14px; font-weight: 700;">
                            <div style="line-height: 48px;">추천인 코드</div>
                            <div style="position: absolute; top: -20px; left: 60px; font-size: 12px; font-weight: 500; line-height: 24px; background-color: #fff; border-radius: 16px; border-bottom-left-radius: 0; color: #210f03; padding: 2px 8px; white-space: nowrap;">친구를 초대하면 무료!</div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="type === POSITION_TYPE.LITE">
                <PositionLite :showQr="showQr"></PositionLite>
            </template>
            <template v-else>
                <PositionPro :showQr="showQr"></PositionPro>
            </template>
            <!-- <div style="background-color: #341A00;">
                <div style="padding: 0 20px;">
                    <div style="padding-top: 32px;">
                        <img style="width: 70px;" :src="require('@/assets/img/title.png')" alt="">
                    </div>
                    <div style="margin-top: 20px; display: flex; flex-direction: column; align-items: center;">
                        <div @click="showPolicy" style="color: #fff; margin-top: 12px; font-weight: 500; font-size: 12px; line-height: 20px; cursor: pointer;">{{ footerText.title2 }}</div>
                        <div @click="showChatWithAdmin" style="color: #fff; margin-top: 12px; font-weight: 500; font-size: 12px; line-height: 20px; padding-bottom: 32px; cursor: pointer;">{{ footerText.title3 }}</div>
                    </div>
                </div>
            </div> -->
            <div style="z-index: 110;">
                <PrivacyPolicy :isShowPrivacyPolicy="isShowPrivacyPolicy" :closePrivacyPolicy="closePrivacyPolicy"></PrivacyPolicy>
            </div>
        </div>
        <LearnSoccerWriteForm :refresh="refresh" :isShowWriteForm="isShowWriteForm" :closeWriteForm="closeWriteForm" :formType="'POSITION'"></LearnSoccerWriteForm>
    </div>
</template>

<script>
import PositionPro from '@/components/common/PositionPro'
import PositionLite from '@/components/common/PositionLite'
import LearnSoccerWriteForm from '@/components/soccerhowmain/LearnSoccerWriteForm'
import PrivacyPolicy from '@/components/modal/PrivacyPolicy'
import { POSITION_TYPE } from '@/Constants'
import Util from "../../modules/util";
import ResponseCode from "../../ResponseCode";

export default {
    name: 'FindPositionProMain',
    components: { PrivacyPolicy, PositionPro, PositionLite, LearnSoccerWriteForm },
    props: {
        type: {
            type: String,
            default: POSITION_TYPE.PRO
        },
        isSignup: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            subTitle: '전문가가 추천하는 내 축구 포지션이 궁금하신가요?<br>심층적인 질문과 답변으로 한층 더 디테일하게 내 포지션을 찾으세요.',
            isShowPrivacyPolicy: false,
            POSITION_TYPE: POSITION_TYPE,
            isShowWriteForm: false,
            isShowRecommendCodePopup: false,
            available_cnt: 0,
            position_try_count: 0,
            isAvailableFindProFree: false,
            is_pass: false,
            price : 900,
        }
    },
    computed: {
        headerText() {
            return this.$i18n.messages[this.$i18n.locale].main_page.header;
        },
        footerText() {
            return this.$i18n.messages[this.$i18n.locale].main_page.footer;
        },
        myRecommendCode() {
            return this.$GlobalStore.loginInfo().recommend_code
        }
    },
    methods: {
        showRecommendCodePopup() {
            this.isShowRecommendCodePopup = true
        },
        closeRecommendCodePopup() {
            this.isShowRecommendCodePopup = false
        },
        closeWriteForm() {
            this.isShowWriteForm = false
        },
        setType(type) {
            this.type = type
            if (this.type === POSITION_TYPE.LITE) {
                this.subTitle = this.headerText.sub_title.lite
            } else {
                this.subTitle = this.headerText.sub_title.pro
            }
        },
        refresh(isComplete) {
            if (isComplete) {
                this.startFindPosition()
            }
        },
        copyMyRecommendCode() {
            this.$Util.sendEventClick('포지션프로_추천인코드_복사', true)
            this.$Util.copyToClipboard(this.myRecommendCode)
        },
        shareUrl() {
            const url = 'https://app.soccerhow.com/position_pro';
            console.log(url);
            const message = '';
            const device = this.$cookies.get('device');
            if (device === 'android') {
                const text = (message === "" ? "" : message + "\n") + url;
                window.Android.shareUrl(text);
            } else if (device === 'ios') {
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'shareUrl', text: message, url: url });
            } else {
                navigator.share({
                    title: message,
                    url: url
                }).then(() => {
                    console.log('Thanks for sharing!');
                }).catch(() => {
                    console.log('share error');
                });
            }
        },
        showChatWithAdmin() {
            this.$Util.showChatWithAdmin()
        },
        closePrivacyPolicy() {
            this.isShowPrivacyPolicy = false
        },
        showPolicy() {
            this.isShowPrivacyPolicy = true
        },
        findPositionPro() {
            window.completeRewardAds = (reward_type, amount) => {
                reward_type; amount;
                this.$GlobalStore.addModal('MyPositionProMain')
            };

            const device = this.$cookies.get('device');

            if (device === 'android') {
                window.Android.showRewardAds();
            } else if (device === 'ios') {
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'showRewardAds' });
            } else {
                alert('앱에서만 가능합니다.');
            }
        },
        showQr(isPro = false) {
            if (isPro) {
                this.isPro = true
            }
            this.isShowQr = true
        },
        closeQr() {
            this.isShowQr = false
            this.isPro = false
        },
        async checkIsWrite() {
            this.startFindPosition()
            // let isSoccerHowLearnWritten
            // const res = await this.$Axios.get('/api/soccerhow/check/learn/written')

            // isSoccerHowLearnWritten = res.data.isSoccerHowLearnWritten

            // if (isSoccerHowLearnWritten) {
            // } else {
            //     this.isShowWriteForm = true
            // }
        },
        startFindPosition() {
            this.$GlobalStore.addModal('FindPositionLite', { isSignup: this.isSignup })
        },
        async getAvailabeCnt() {
            const res = await this.$Axios.get('/api/position/available/cnt')
            this.available_cnt = res.data.available_cnt
            this.isAvailableFindProFree = res.data.is_free_availble
            this.checkCondition()
        },
        async checkCondition() {
            const res = await this.$Axios.get('/api/position/free/check')

            const isScheduleComplete = res.data.isScheduleComplete
            const isShareComplete = res.data.isShareComplete
            const isShared = JSON.parse(localStorage.getItem('isShared'))

            if (isScheduleComplete && isShared && !isShareComplete && this.isAvailableFindProFree) {
                this.$GlobalStore.setIsShowCompleteProCondition()
            }

            if (isScheduleComplete && isShareComplete) {
                localStorage.removeItem('isShared')
            }
        },
        async payAction(pay_method, pay_mode, card_idx, selected_pay_methods) {
            selected_pay_methods;
            const parameters = {};
            parameters.pay_mode = pay_mode;
            parameters.amt = this.price;
            parameters.goods_name = '포지션 프로 비용';
            parameters.memo = '';
            parameters.card_idx = card_idx;

            this.$GlobalStore.showProgress();

            await Util.payIntegrated(pay_method, parameters, async (converted_parameters) => {
                return await this.$Axios.post('/api/position/pay', converted_parameters);
            }, async (converted_parameters) => {
                const res = await this.$Axios.post('/api/position/pay', converted_parameters);
                this.$GlobalStore.hideProgress()
                if (res.data.code === ResponseCode.SUCCESS) {
              /*      this.$GlobalStore.addModal('CompletePay', { payMethodObj: selected_pay_methods, completeAction: () => {

                        }
                    });*/
                    this.$GlobalStore.closeLastModal();
                    this.$GlobalStore.addModal('MyPositionProMain')
                    this.getAvailabeCnt();
                    // this.$GlobalStore.addModal('MyPositionPro', { originallyPosition: this.originallyPosition })
                    this.is_pass = true
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            });
        },
        paymentPositionPro() {
            this.$GlobalStore.addModal('Payment', { payAction: this.payAction, goods_name: '포지션 찾기 PRO', amt: this.price });
        },
        showMyPositionProMain(){
            this.$GlobalStore.addModal('MyPositionProMain', {is_free: this.isAvailableFindProFree})
        },
        showPopupOrFreePro(){
            if(this.isAvailableFindProFree || this.available_cnt > 0){
                this.$GlobalStore.addModal('MyPositionProMain', {is_free : this.isAvailableFindProFree})
            } else {
                this.showRecommendCodePopup();
            }
        },

    },
    created() {
        this.payAction = this.$Once(this.payAction);
        this.getAvailabeCnt();
    }
}
</script>

<style scoped></style>